<template>
  <div>
    <div class="home-logon flex-end">
      <template v-if="isLogin">
        <span class="pointer logout m-r-9" @click="logout()">{{ $t('退出') }}</span>
        <span class="pointer logout m-r-9" @click="goHome()" v-if="!routerList.includes(routerName)">{{ $t('home')
          }}</span>
        <div class="logonBtn pointer" @click="goCollection()" v-if="routerName != '/actorCollection'">{{ $t('我的收藏') }}
        </div>
      </template>
      <div class="logonBtn pointer" @click="goLogin()" v-else>{{ $t('用户登录') }}</div>
      <div class="langBtnBox pointer flex">
        <div @click="setLang('zh')" class="langBtn zhong" :class="language == 'zh' ? 'selecteBtnZhong' : ''">中</div>
        <div @click="setLang('en')" class="langBtn ying" :class="language == 'en' ? 'selecteBtnying' : ''">EN</div>
      </div>
    </div>
    <div style="margin: auto;text-align: center;">
      <img v-if="language == 'zh'" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/banner1-cn.png" />
      <img v-else src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/banner1-en.png" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    computed: {
      ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
    },
    data() {
      return {
        routerName: this.$route.path,
        routerList: ['/', '/actorList']
      }
    },
  methods: {
      // 返回首页
      goHome() {
        sessionStorage.removeItem('actorID')
        this.$router.push('/')
      },
      // 语言切换
      setLang(language) {
        this.$i18n.locale = language
        this.$store.commit('SET_LANGUAGE', language)
        location.reload()
      },
      // 登录
      goLogin() {
        sessionStorage.removeItem('actorID')
        this.$router.push('/login/person')
      },
      // 我的收藏
      goCollection() {
        this.$router.push('/actorCollection')
      },
      // 退出登录
      logout() {
        sessionStorage.removeItem('actorID')
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push('/')
        })
      }
    },
  async mounted() {
     }
  }
</script>

<style lang="stylus" scoped>
.home-logon {
  position: absolute;
  top: 48px;
  right: 16.66%;
  width: 100%;
  text-align: right;
  background:transparent;
  padding-top: 0px;
  align-items: flex-end;

  .logonBtn {
    background: linear-gradient(180deg, #93CEB0 0%, #0068A9 100%);
    border-radius: 20px;
    border: 2px solid #FFFFFF;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 25px;
    padding: 4px 22px;
    margin-right: 20px;

  }
  .langBtnBox{
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 25px;
    margin-right: 20px;
    .langBtn{
      font-size: 18px;
      color: #FFFFFF;
      padding: 4px 22px;
    }
    .zhong{
      padding-right:12px;
      border: 2px solid rgba(255,255,255,0.85);
      border-radius: 20px 0 0 20px;
      border-right:none;

    }
    .ying{
      padding-left:12px;
      border: 2px solid rgba(255,255,255,0.85);
      border-radius: 0px 20px 20px 0px;
      border-left:none;
    }
    .selecteBtnZhong{
      border: 2px solid rgba(255,255,255,1);
      background: linear-gradient( 180deg, #93CEB0 0%, #0068A9 100%);
    }
    .selecteBtnying{
      border: 2px solid rgba(255,255,255,1);
      background: linear-gradient( 180deg, #93CEB0 0%, #0068A9 100%);
    }
  }
  .logout{
      font-size: 16px;
      color: #FFFFFF;
      line-height: 25px;
      padding: 0;
      margin-right:20px;
      text-decoration: underline;
  }
}


@media (min-width: 320px) and (max-width: 750px) {
  .home-logon{
    position:relative;
    top: 0;
    right: 0;
    background:linear-gradient(90deg, #00875e 0%, #0068a9 100%);
    padding-top: 10px;
    .logonBtn{
      font-size: 11px;
      line-height: 25px;
      padding: 1px 7px;
    }
    .langBtnBox{
      font-size: 11px;
      line-height: 25px;
      margin-right: 10px;
      .langBtn{
        font-size: 11px;
        padding: 1px 7px;
      }
    }
    .logout{
      font-size: 12px;
    }
  }
  
  
}
</style>